import React, {useMemo} from 'react'
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image
} from '@react-pdf/renderer'

import logo from '../../../../../_websoft/assets/images/logo.jpg'
import ceznak from '../../../../../_websoft/assets/images/ceznak.png'

import {Font} from '@react-pdf/renderer'
import {dopTranslations} from '../../../../translations/dopTranslations'

// FONTS
Font.register({
    family: 'Roboto',
    src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf',
})

Font.register({
    family: 'Roboto',
    src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf',
    fontWeight: 300,
})

const CELL_BG = '#FEF1CB'

const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 7.5,
        fontFamily: 'Roboto',
        fontWeight: 300
    },

    row: { flexDirection: 'row' },

    spaceBetween: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },

    labelCell: {
        width: '35%',
        padding: 6,
        backgroundColor: CELL_BG,
        borderWidth: 0.2
    },

    valueCell: {
        flex: 1,
        padding: 8,
        borderWidth: 0.2
    },

    col1: {
        width: '35%',
        padding: 4,
        backgroundColor: CELL_BG,
        borderWidth: 0.2
    },

    col2: {
        flex: 1,
        flexDirection: 'row',
        borderWidth: 0.2,
        justifyContent: 'center',
        alignItems: 'center'
    },

    col3: {
        width: '18%',
        borderWidth: 0.2,
        justifyContent: 'center',
        alignItems: 'center'
    },

    innerCell: {
        flex: 1,
        padding: 1,
        fontSize: 7,
        textAlign: 'center',
        borderRightWidth: 0.5,
    },

    innerCellLast: {
        flex: 1,
        padding: 1,
        fontSize: 7,
        textAlign: 'center'
    },

    bold: { fontWeight: 'bold' },

    small: { fontSize: 12 },

    title: {
        fontSize: 16,
        fontWeight: 'bold'
    },

    footerBox: {
        marginTop: 5,
        padding: 6,
        borderLeft: '5px solid #fddd80',
        backgroundColor: '#f5f5f5',
        fontSize: 7,
    }
})

const DopPdfDocument: React.FC<{
    dop: any
    matrix: any
    dopItems: any[]
    debljine: string[]
    debljineLimova: any
}> = ({dop, matrix, dopItems, debljine, debljineLimova}) => {


    const lang = dop?.Jezik || 'En'

    console.log('asdasd');
    console.log(debljineLimova, 'debljineLimova');
    const t = (key: string) =>
        dopTranslations?.[lang]?.[key] ||
        dopTranslations?.['en']?.[key] ||
        key

    const renderLabel = (bs: string, key?: string) => (
        <Text>
            <Text style={styles.bold}>{bs}</Text>
            {key && <Text> ({t(key)})</Text>}
        </Text>
    )

    const getRowValues = (item: any) => {
        if (!item || !item.Id) {
            return debljine.map(() => '-')
        }

        return debljine.map((d) => matrix?.[item.Id]?.[d] || '-')
    }

    const reakcijaNaVatru = useMemo(
        () => dopItems.find((i: any) => i.Numeracija === 'II'),
        [dopItems]
    )

    const otpornostNaVatru = useMemo(
        () => dopItems.find((i: any) => i.Numeracija === 'III'),
        [dopItems]
    )

    const filteredItems = useMemo(
        () => dopItems.filter(
            (item: any) =>
                item.Numeracija !== 'II' && item.Numeracija !== 'III'
        ),
        [dopItems]
    )

    const getItemTranslation = (item: any) => {
        const lang = dop?.Jezik || 'En'

        if (lang === 'De') return item.NazivDe
        if (lang === 'Sl') return item.NazivSl
        if (lang === 'Es') return item.NazivEs

        // default → English
        return item.NazivEng

    }
    return (
        <Document>
            <Page size='A4' style={styles.page}>
                {/* HEADER */}
                <View style={[styles.spaceBetween, {marginBottom: 10}]}>
                    <View>
                        <Text style={styles.title}>IZJAVA O SVOJSTVIMA</Text>
                        <Text style={styles.small}>({t('declaration')})</Text>

                        <Text style={styles.small}>{dop?.IdentifikacijskaOznakaVProizvoda}</Text>
                        <Text style={styles.small}>{dop?.NazivDopa}</Text>
                    </View>

                    <View style={{flex: 1, alignItems: 'flex-end'}}>
                        <View style={{alignItems: 'center'}}>
                            <Image src={ceznak} style={{width: 50}} />
                            <Text style={{marginTop: -5, fontSize: 9}}>NB 1396</Text>
                        </View>
                        <Image src={logo} style={{width: 200, marginTop: 10}} />
                    </View>
                </View>

                {/* BASIC TABLE */}
                {[
                    {bs: '1. Jedinstvena identifikacijska oznaka vrste proizvoda', key: 'uniqueCode', value: dop?.IdentifikacijskaOznakaVProizvoda},
                    {bs: '2. Područje primjene', key: 'intendedUse', value: dop?.PodrucjePrimjene},
                    {bs: '3. Proizvođač', key: 'manufacturer', value: dop?.Proizvodjac},
                    {bs: '4. Ovlašteni zastupnik', key: 'representative', value: dop?.OvlasteniZastupnik},
                    {bs: '5. Sistem ocjenjivanja', key: 'system', value: dop?.SistemiOcjenjivanja},
                    {bs: '6a. Usklađeni standard', key: 'standard', value: dop?.UskladjeniStandard},
                    {bs: 'Obavještajno tijelo', key: 'notifiedBody', value: dop?.ObavjestajnoTijelo},
                    {bs: 'Dokument o EU ocjenjivanju', key: 'document', value: dop?.DokumentOEuOcjenjivanju},
                    {bs: 'Deklarisana svojstva', key: 'declared', value: dop?.DeklarisanaSvojstva},
                ].map((row, i) => (
                    <View key={i} style={styles.row}>
                        <View style={styles.labelCell}>
                            {renderLabel(row.bs, row.key)}
                        </View>
                        <View style={styles.valueCell}>
                            <Text>{row.value || '-'}</Text>
                        </View>
                    </View>
                ))}

                {/* MATRIX */}
                <View style={{marginTop: 10}}>
                    <View style={styles.row}>
                        <View style={styles.col1}>
                            {renderLabel('Ključne karakteristike', 'keyFeatures')}
                        </View>
                        <View style={[styles.col2, {backgroundColor: CELL_BG}]}>
                            {renderLabel('Deklarisana svojstva', 'declaredPerformance')}
                        </View>
                        <View style={[styles.col3, {backgroundColor: CELL_BG}]}>
                            <Text style={styles.bold}>Uskl. Stand.</Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.col1}>
                            {renderLabel('I) Izolacija', 'insulation')}
                        </View>
                        <View style={styles.col2}>
                            <Text>{dop?.izolacija_panela?.naziv || '-'}</Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.col1}>
                            {renderLabel('II) Reakcija na vatru', 'reactionToFire')}
                        </View>
                        <View style={styles.col2}>
                            {getRowValues(reakcijaNaVatru).map((v, i) => (
                                <View key={i} style={i === debljine.length - 1 ? styles.innerCellLast : styles.innerCell}>
                                    <Text>{v}</Text>
                                </View>
                            ))}
                        </View>
                        <View style={styles.col3}>
                            <Text>{reakcijaNaVatru?.Standard || '-'}</Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.col1}>
                            {renderLabel('III) Otpornost na vatru', 'fireResistance')}
                        </View>
                        <View style={styles.col2}>
                            {getRowValues(otpornostNaVatru).map((v, i) => (
                                <View key={i} style={i === debljine.length - 1 ? styles.innerCellLast : styles.innerCell}>
                                    <Text>{v}</Text>
                                </View>
                            ))}
                        </View>
                        <View style={styles.col3}>
                            <Text>{otpornostNaVatru?.Standard || '-'}</Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.col1}>
                            {renderLabel('IV) Materijal lice / naličje', 'material')}
                        </View>
                        <View style={styles.col2}>
                            <Text>
                                {dop?.kvalitet_materijala?.MatKvalitetNaziv || '-'}{' '}
                                {debljineLimova?.debljinaLimaGore} / {debljineLimova?.debljinaLimaDole}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.col1}>
                            {renderLabel('V) Nominalna debljina', 'thickness')}
                        </View>
                        <View style={styles.col2}>
                            {debljine.map((d, i) => (
                                <View key={d} style={i === debljine.length - 1 ? styles.innerCellLast : styles.innerCell}>
                                    <Text style={styles.bold}>{d}</Text>
                                </View>
                            ))}
                        </View>
                    </View>

                    {filteredItems.map((item) => (
                        <View key={item.Id} style={styles.row}>
                            <View style={styles.col1}>
                                <Text>
                                    <Text style={styles.bold}>
                                        {item.Numeracija} {item.Naziv}
                                    </Text>

                                    {getItemTranslation(item) && (
                                        <Text> ({getItemTranslation(item)})</Text>
                                    )}
                                </Text>
                            </View>

                            <View style={styles.col2}>
                                {debljine.map((d, i) => (
                                    <View key={d} style={i === debljine.length - 1 ? styles.innerCellLast : styles.innerCell}>
                                        <Text>{matrix?.[item.Id]?.[d] || '-'}</Text>
                                    </View>
                                ))}
                            </View>

                            <View style={styles.col3}>
                                <Text>{item.Standard || '-'}</Text>
                            </View>
                        </View>
                    ))}
                </View>

                {/* FOOTER */}
                <View style={styles.footerBox}>
                    <Text>
                        Svojstva proizvoda utvrđena iznad su u skladu sa setom objavljenih svojstava.
                        Ova izjava o svojstvima objavljena je u skladu sa Uredbom o građevinskim proizvodima broj 305/2011.
                    </Text>

                    <Text style={{marginTop: 2}}>
                        {t('svojstva')}
                    </Text>

                    <View style={{marginTop: 5}}>
                        <Text> Napomene / {t('notes')}:</Text>
                        <Text>• Atestna dokumentacija otpornosti na vatru se izdaje na zahtjev kupca ({t('fireDoc')})</Text>
                        <Text>• Kapaciteti momenta savijanja su dati za debljinu lima 0,4/0,4 ({t('bending')} {debljineLimova?.debljinaLimaGore} / {debljineLimova?.debljinaLimaDole} )</Text>
                        <Text>• 3 U skladu sa EN-14509, EN-13165 i korištenim materijalima, ova karakteristika je potvrđena bez testiranja ({t('noTesting')})</Text>
                        <Text>• NPD = no performance declared</Text>
                    </View>

                    <View style={[styles.spaceBetween, {marginTop: 5}]}>
                        <View style={{ marginTop: 0 }}>
                            {/* Bosnian */}
                            <Text>
                                Za proizvođača i u njegovo ime potpisao
                            </Text>

                            {/* English */}
                            <Text style={{ fontSize: 8, color: '#666', marginTop: 2 }}>
                                ({t('signedBy')})
                            </Text>
                        </View>
                        <View>
                            <Text>Salih Lemeš</Text>
                            <Text>General Manager</Text>
                            <Text>
                                Sarajevo, Bosnia & Herzegovina
                            </Text>
                            <Text>21 August 2023</Text>
                        </View>
                    </View>
                </View>

            </Page>
        </Document>
    )
}

export default DopPdfDocument